// extracted by mini-css-extract-plugin
module.exports = {"list":"MediaDetailsDescriptionList_list__yAO9a","listItem":"MediaDetailsDescriptionList_listItem__7tx90"};